import { HTMLAttributes } from 'react';
import { FontSize, FontWeight } from 'commons';
import { TextStyle } from './styles';

interface Props extends HTMLAttributes<HTMLElement> {
  as?: 'p' | 'span';
  size?: FontSize;
  weight?: FontWeight;
}

/**
 *
 * @param as set the html tag of the text, default is 'p'
 * @param size set the size of the text
 * @param weight set the font weight
 * @description more specific styles can be done by customizing the TextStyle styledComponent in a parent styledComponent
 */
export function Text({
  as = 'p',
  size = FontSize.font14,
  weight = FontWeight.regular,
  children,
  ...rest
}: Props) {
  return (
    <TextStyle as={as} $size={size} $weight={weight} {...rest}>
      {children}
    </TextStyle>
  );
}

export { TextStyle };
